import { Authenticator } from '../types';

import { MsalPopupAuthenticator } from '.';

type IsMsalPopupAuthenticator = (authenticator: Authenticator) => authenticator is MsalPopupAuthenticator;
export const isMsalPopupAuthenticator: IsMsalPopupAuthenticator = (
  authenticator: Authenticator
): authenticator is MsalPopupAuthenticator =>
  (authenticator as MsalPopupAuthenticator).initializeCurrentAccount !== undefined;
